// BrandMarquee.js
import { Container } from "react-bootstrap";
import Marquee from "react-fast-marquee";
import { useGetAllClientsQuery } from "../../../../redux/api/ClientsApi/clientsApi";

const BrandMarquee = () => {
  const { data, isLoading } = useGetAllClientsQuery({
    limit: 100,
    sortBy: "display_order",
    order: "asc",
  });

  if (isLoading) {
    return null; // Or a spinner/skeleton if preferred
  }

  // Filter active clients
  const activeClients = (data?.data || []).filter((client) => client.status);

  if (activeClients.length === 0) return null;

  return (
    <div style={{ background: "#fff", padding: "60px 0" }}>
      <Container>
        <h2 className="text-center fw-bold mb-5" style={{ color: "#009fe3" }}>
          Trusted by Top Brands
        </h2>

        <Marquee
          direction="left"
          gradient={true}
          gradientWidth={100}
          speed={40}
          pauseOnHover
        >
          {activeClients.map((client) => (
            <div
              key={client.id}
              className="brand-logo-card"
              title={client.client_name}
            >
              {client.client_logo && (
                <img
                  src={client.client_logo}
                  alt={client.client_name}
                  style={{
                    maxHeight: "55px",
                    maxWidth: "100%",
                    objectFit: "contain",
                    filter: "grayscale(10%) contrast(90%)",
                    transition: "filter 0.3s ease"
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.filter = "grayscale(0%)"}
                  onMouseLeave={(e) => e.currentTarget.style.filter = "grayscale(10%) contrast(90%)"}
                />
              )}
            </div>
          ))}
        </Marquee>
      </Container>
    </div>
  );
};

export default BrandMarquee;